// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"03113528","453":"a0d61c50"}[chunkId] + ".chunk.js";
};